import { render, staticRenderFns } from "./PayMethodPopup.vue?vue&type=template&id=4fcb0b48&scoped=true"
import script from "./PayMethodPopup.vue?vue&type=script&lang=js"
export * from "./PayMethodPopup.vue?vue&type=script&lang=js"
import style0 from "./PayMethodPopup.vue?vue&type=style&index=0&id=4fcb0b48&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcb0b48",
  null
  
)

export default component.exports